import gql from 'graphql-tag'

export const PAPER_CHECK = gql`
  mutation PaperCheck($request: PaperCheckInput!) {
    paperCheck(request: $request) {
      paperId
      sentences {
        id
        position {
          length
          offset
        }
      }
    }
  }
`

export const SENTENCE_CHECK = gql`
  mutation SentenceCheck($request: SentenceCheckInput!) {
    sentenceCheck(request: $request) {
      isSuccess
    }
  }
`

export const GET_PAPER = gql`
  query GetPaper($paperId: UUID!) {
    getPaper(paperId: $paperId) {
      requiresReCheck
      title
      paperContent
      paperId
      feedbackState {
        sentences {
          id
          position {
            length
            offset
          }
        }
        feedbackList {
          changeType
          feedbackType
          id
          position {
            offset
            length
          }
          reason
          sentenceId
          suggestedText
        }
      }
      createdAt
    }
  }
`

export const GET_PAPER_LIST = gql`
  query GetPaperList($before: String, $after: String) {
    getPaperList(before: $before, after: $after) {
      papers {
        paperId
        title
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`
